define((require) => {
    "use strict";

    const IntegrationsView             = require("editor/ui/settings/integrations/IntegrationsView");
    const Promise                      = require("shared/util/Promise");
    const LoggedInUserState            = require("shared/ui/user/LoggedInUserState");
    const ExperienceMetadataCollection = require("ui/experience/ExperienceMetadataCollection");
    const Marionette                   = require("marionette");
    const Permissions = require("shared/security/Permissions");

    return Marionette.Controller.extend({
        /**
         * Show integrations page.
         * @param {Backbone.Collection<IntegrationModel>} integrationsCollection a collection of integration models
         * @param {String} [tabName] The tabName that you wanna explicitly show; optional.
         */
        showIntegrations(tabName) {
            const integrationsCollection = LoggedInUserState.get("integrations");

            Promise
                .all([
                    LoggedInUserState.get("companySettings").fetch(),
                    ExperienceMetadataCollection.experiences(),
                    // Fetch the prototype action collection to update the usage info lists. The
                    // returned value is not used here.
                    LoggedInUserState.get("prototypeActionCollection").fetch()
                ])
                .then((results) => {
                    const [settings, experiences] = results;

                    this.options.region.show(new IntegrationsView({
                        model: settings,
                        experiences,
                        tabName: tabName,
                        integrationsCollection,
                        isManager: Permissions.Roles.MANAGER.is()
                    }));
                });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/IntegrationsController.js